import { Base } from '@gate31/core/src/libs/BaseComponent';
import EventBus from 'EventBus';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { faro } from '@gate31/faro/src';
import { CustomCn } from '@gate31/core/src/libs/classname';

class ProductFormActionError extends Error {
    name = 'ProductFormActionError'
}

export class ProductFormAction extends Base<HTMLElement> {
    private cn: CustomCn;

    DATA_UI_FAVORITES_TRIGGER = 'data-ui-favorites-trigger';
    DATA_BTN_TEXT = 'data-btn-text';

    product: InsalesProduct;
    // eslint-disable-next-line
    variant: Record<string, any>;

    notUseSizeMassage: HTMLElement;

    buttonFake: HTMLButtonElement;
    buttonAvailable: HTMLButtonElement;
    buttonNotAvailable: HTMLButtonElement;

    constructor({ node, product, cn }: { node: HTMLElement; product: InsalesProduct; cn: CustomCn }) {
        super(node);

        this.product = product;
        this.cn = cn;

        this.notUseSizeMassage = this.getRoot().querySelector(this.cn.setElem('not-use-size-message').toSelector()) as HTMLButtonElement;

        this.buttonFake = this.getRoot().querySelector(this.cn.setElem('btn-fake').toSelector()) as HTMLButtonElement;
        this.buttonAvailable = this.getRoot().querySelector(this.cn.setElem('btn-available').toSelector()) as HTMLButtonElement;
        this.buttonNotAvailable = this.getRoot().querySelector(this.cn.setElem('btn-not-available').toSelector()) as HTMLButtonElement;

        this.callbackConnection();
    }

    showNotUseSizeMassage() {
        const activeClass = this.cn.setElem('not-use-size-message').setMode({ active: true }).toString();

        this.notUseSizeMassage.classList.add(activeClass);
    }
    hideNotUseSizeMassage() {
        const activeClass = this.cn.setElem('not-use-size-message').setMode({ active: true }).toString();

        this.notUseSizeMassage.classList.remove(activeClass);
    }

    chooseButton() {
        if (this.isSizeSelected()) { // Если размер выбран
            const checkedId = this.getCheckedSizeId(); // id Выбранного варианта

            this.hideNotUseSizeMassage();

            this.toggleDisableButtonAddCard(false);

            // @ts-expect-error
            if (this.product.variantAvailable(checkedId)) {
                // Товар в наличии => Показать кнопку добавление в корзину
                this.showSelectedButton('available');
            } else {
                // Товар не в наличии => Показать кнопку подписки
                this.showSelectedButton('not-available');
            }
        } else {
            // Если размер не выбран то показываем фуйковую кнопку
            this.showSelectedButton('fake');
        }
    }

    toggleDisableButtonAddCard(isDisableBtn: boolean) {
        if (isDisableBtn) {
            this.buttonAvailable.setAttribute('disabled', 'true');
        } else {
            this.buttonAvailable.removeAttribute('disabled');
        }
    }

    isSizeSelected(): boolean {
        return Boolean(this.getRoot().querySelector('[name="razmer"]:checked'));
    }

    getCheckedSizeId() {
        const input = this.getRoot().querySelector<HTMLInputElement>('[name="razmer"]:checked');

        if (! input) {
            const error = new ProductFormActionError('not found checked size');

            return faro.api.pushError(error, {
                context: {
                    section: `product form action desk - ${error}`
                }
            });
        }

        return input.value;
    }

    showSelectedButton(variantButton: 'not-available' | 'available' | 'fake') {
        switch (variantButton) {
            case 'available':
                this.buttonFake.style.display = 'none';
                this.buttonAvailable.style.display = 'flex';
                this.buttonNotAvailable.style.display = 'none';
                break;
            case 'not-available':
                this.buttonFake.style.display = 'none';
                this.buttonAvailable.style.display = 'none';
                this.buttonNotAvailable.style.display = 'flex';
                break;
            case 'fake':
                this.buttonFake.style.display = 'flex';
                this.buttonAvailable.style.display = 'none';
                this.buttonNotAvailable.style.display = 'none';
                break;
            default:
                break;
        }
    }

    openPnnModal() {
        const productId = this.product.product.id;
        const variantTitle = `${this.product.product.title} ${this.variant.title}`;
        const variantId = this.variant.id;

        setTimeout(() => {
            window.pnn.init(productId, variantTitle, variantId);
        }, 0);
    }

    callbackConnection() {
        this.buttonFake?.addEventListener('click', () => {
            this.showNotUseSizeMassage();
        });

        this.buttonNotAvailable?.addEventListener('click', () => {
            this.openPnnModal();
        });

        EventBus.subscribe('update_variant:insales:product', data => {
            this.variant = data;
            this.chooseButton();
        });

        document.querySelectorAll(`[${this.DATA_UI_FAVORITES_TRIGGER}]`).forEach(button => {
            button.querySelector(`[${this.DATA_BTN_TEXT}]`)?.setAttribute('data-ui-favorites-trigger-added-text', 'Убрать из избранного');
            button.querySelector(`[${this.DATA_BTN_TEXT}]`)?.setAttribute('data-ui-favorites-trigger-not-added-text', 'Добавить в избранное');
        });
    }
}
